// @ts-nocheck 7775b19b
import constants from '#packages/constants';

const { ACTIONS } = constants.ROOT_COMPS.GFPP;

export default {
  mainActions: [],
  enabledActions: [ACTIONS.SETTINGS, ACTIONS.DESIGN],
  mobileMainActions: [],
  mobileEnabledActions: [],
};
